import { render, staticRenderFns } from "./MailThread.vue?vue&type=template&id=db922c02&scoped=true"
import script from "./MailThread.vue?vue&type=script&lang=js"
export * from "./MailThread.vue?vue&type=script&lang=js"
import style0 from "./MailThread.vue?vue&type=style&index=0&id=db922c02&prod&lang=scss&scoped=true"
import style1 from "./MailThread.vue?vue&type=style&index=1&id=db922c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db922c02",
  null
  
)

export default component.exports